<script lang="ts">
	import type { RouteDataSuccess } from '../types';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as m from '$paraglide/messages';

	export let evData: RouteDataSuccess['data']['evData'];

	function getBatteryIcon(chargeLevel: number): string {
		if (chargeLevel < 20) {
			return 'battery-2';
		} else if (chargeLevel < 40) {
			return 'battery-3';
		} else if (chargeLevel < 60) {
			return 'battery-4';
		} else if (chargeLevel < 80) {
			return 'battery-5';
		} else {
			return 'battery-6';
		}
	}
</script>

{#if evData}
	<div class="flex items-center">
		<span>{m.route__recharge({ count: evData.rechargePoints.length })}</span><span>•</span>
		<span class="flex">
			{m.route__final_charge()}
			{evData.finalChargeLevel}%
			<Icon class="self-center" icon={getBatteryIcon(evData.finalChargeLevel)} />
		</span>
	</div>
{/if}
